import React from "react";
import "./Wheel.css";
import Lock from "../../../assets/lock.png";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
// import Wildlife from '../../../assets/books/org/wildlife.png';
import Wildlife from "../../../assets/Icons/books/empty_card_placeholder-01 1.svg";
import { useIsVideoTheme } from "../../Layout/ThemeBackground/ThemeBackground";
import {
  IMAGE_INACTIVE_OPACITY,
  IMAGE_SEGMENT_FILL,
  VIDEO_INACTIVE_FILL,
  VIDEO_INACTIVE_OPACITY,
  VIDEO_SEGMENT_FILL,
} from "./wheelColor";

const getMyCords = (theta, radius) => {
  return {
    x: Math.cos(theta) * radius,
    y: Math.sin(theta) * radius,
  };
};

function WheelCard(props) {
  const isVideoTheme = useIsVideoTheme();
  let newCords = getMyCords(props.theta, props.radius);
  const book = props?.bookData?.[props?.id];
  const hasBook = Boolean(book?._id);

  const handleNavigation = () => {
    if (!props.isPreview) {
      if (props.type === "active") {
        if (!hasBook) return;
        props.startHandler(book._id, props.isLocked);
      } else {
        props.selectedBookHandler(props.id, props.itemRotation);
      }
    }
  };
  const companyBookWheelStyle = props.bookType != "ORG"?{
    display:"flex",
    justifyContent:"center"
  }:{}
  return (
    <>
      <div
        onClick={handleNavigation}
        className={`${props.bookType != "ORG" && "cardColor"} ${
          props.bookType != "COMPANY" && "cardColor"
        } card ${props.type} `}
        style={{
          background: isVideoTheme
            ? props.type === "active"
              ? VIDEO_SEGMENT_FILL
              : VIDEO_INACTIVE_FILL
            : IMAGE_SEGMENT_FILL,
          cursor: props.type === "active" && hasBook ? "pointer" : "",
          // scale: props.type === "active" ? "1.08" : "",
          left: `${props.center.x + newCords.x}px`,
          top: `${props.center.y + newCords.y}px`,
          transform: `translate(-50%, -50%) rotate(${
            props.itemRotation
          }deg) scale(${props.type === "active" ? "1.1" : "1"})`,
          opacity:
            props.type === "active"
              ? "1"
              : isVideoTheme
                ? VIDEO_INACTIVE_OPACITY
                : IMAGE_INACTIVE_OPACITY,
          ...companyBookWheelStyle
        }}
      >
        {props.isPublished === false ? (
          <div
            style={{
              display: "flex",
              fontSize: "50px",
              margin: "20px",
              alignItems: "center",
              height: "30%",
              width: "100%",
              position: "absolute",
              zIndex: 2,
            }}
          >
            <InfoOutlinedIcon
              sx={{
                transform: "rotate(335deg)",
                fontSize: "20px",
                color: "#5c5c5c",
              }}
            />
          </div>
        ) : (
          props.isLocked && (
            <div
              style={{
                display: "flex",
                fontSize: "50px",
                margin: "20px",
                alignItems: "center",
                height: "30%",
                width: "100%",
                position: "absolute",
                zIndex: 2,
              }}
            >
              <img
                style={{
                  transform: `rotate(335deg)`,
                }}
                src={Lock}
                width={20}
                alt=""
              />
            </div>
          )
        )}
        <div
          onClick={handleNavigation}
          style={{
            display: "flex",
            fontSize: "50px",
            padding: "10px 10px 20px 10px",
            justifyContent: "center",
          }}
        >
          {props.bookType != "ORG" ? (
            <img
              onClick={handleNavigation}
              style={{
                // position: "relative",
                objectFit: "contain",
                width:"80%"
                // padding:"20px",
                // width: "40%",
                // heighth: "100%",
                // maxHeight: "180px",
              }}
              alt=""
              src={props.coverImage || Wildlife}
            />
          ) : (
            <img
              onClick={handleNavigation}
              style={{
                position: "absolute",
                width: "50%",
                heighth: "100%",
                maxHeight: "180px",
                position: "relative",
              }}
              alt="book-cover"
              src={props.wheelImage || Wildlife}
            />
          )}
        </div>
      </div>
    </>
  );
}

export default WheelCard;
